import {
  doc,
  setDoc,
  getDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';
import { COLLECTIONS, agentUserDocId } from './firestore-schema';

/**
 * Get or create agent user document. Syncs Firebase Auth user into agentUsers.
 * @param {{ uid: string, email?: string, displayName?: string, photoURL?: string }} user
 * @param {{ role?: string, agency?: string }} meta - optional role/agency
 * @returns {Promise<{ uid: string, email: string, displayName?: string, photoURL?: string, role?: string, agency?: string }>}
 */
export async function getOrCreateAgentUser(user, meta = {}) {
  if (!db || !user?.uid) throw new Error('Firebase or user not available');
  const id = agentUserDocId(user.uid);
  const ref = doc(db, COLLECTIONS.USERS, id);
  const snap = await getDoc(ref);
  const now = serverTimestamp();
  const data = {
    uid: user.uid,
    email: (user.email || '').toLowerCase().trim(),
    displayName: user.displayName || null,
    photoURL: user.photoURL || null,
    updatedAt: now,
    ...meta,
  };
  if (!snap.exists()) {
    data.createdAt = now;
    await setDoc(ref, data);
  } else {
    await setDoc(ref, data, { merge: true });
  }
  return { ...data, createdAt: snap.exists() ? snap.data().createdAt : now };
}

export async function getAgentUser(uid) {
  if (!db || !uid) return null;
  const ref = doc(db, COLLECTIONS.USERS, uid);
  const snap = await getDoc(ref);
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}
